import { memo } from "react";
import vars from "utils/vars";
import ToastsListItem from "../ToastsListItem";

const ToastsList = ({ flashes = {}, uiVersionUpdateNeeded, reloadPage }) => (
	<div className="toast-container py-3 px-sm-3 px-md-0 ms-auto w-100 sticky-top">
		{Object.keys(flashes)?.map((type, i) =>
			[...flashes[type]]
				?.sort((a, b) => b?.createdAt - a?.createdAt)
				?.map((message, i2) => (
					<ToastsListItem
						key={`${i}-${i2}`}
						message={message}
						type={type}
						typeIndex={i}
						messageIndex={i2}
						disableAutoHide={message?.is_infinity || undefined}
					/>
				))
		)}
		{uiVersionUpdateNeeded && (
			<ToastsListItem
				message={{ message: `A new version of ${vars.app.name} is available!` }}
				type="info"
				reloadPage={reloadPage}
				isUiVersionUpdate
				disableAutoHide
			/>
		)}
	</div>
);

export default memo(ToastsList);
